import { render, staticRenderFns } from "./AppFallback.vue?vue&type=template&id=1486f7b0&scoped=true"
import script from "./AppFallback.vue?vue&type=script&lang=js"
export * from "./AppFallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1486f7b0",
  null
  
)

export default component.exports